module.exports = __webpack_public_path__ + "img/logo-statusiq.021b790d.png";